import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CustomModal from '@/components/atoms/CustomModal';
import ActivityLogsList from './IndividualLog/ActivityLogsList';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';

export interface ActivityLogsPopupData {
  id: string;
  type: string;
}

export interface ActivityLogsPopupProps {
  isOpen?: boolean;
  onClose?: () => void;
  data?: ActivityLogsPopupData | null;
  id?: string;
  type?: string;
}

export const ActivityLogsPopup: React.FC<ActivityLogsPopupProps> = ({
  isOpen: controlledIsOpen,
  onClose: controlledOnClose,
  data,
  id,
  type,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { modalId, modalExtraData } = usePublicState();

  const isReduxOpen = modalId === 'ACTIVITY_LOGS_POPUP';
  const isModalOpen =
    controlledIsOpen !== undefined ? controlledIsOpen : isReduxOpen;

  const extra = modalExtraData as ActivityLogsPopupData | undefined;
  const activeId = data?.id ?? id ?? extra?.id ?? '';
  const activeType = data?.type ?? type ?? extra?.type ?? 'PRODUCT';

  const handleClose = () => {
    controlledOnClose?.();
    if (isReduxOpen) {
      dispatch(setModalId({ id: null }));
    }
  };

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={handleClose}
      title={t('activityLogs.logActivity')}
      closable
      centered
      width={700}
    >
      <div
        className="flex flex-col gap-4 max-h-[70vh] overflow-y-auto px-1"
        data-testid="activity-logs-popup-content"
      >
        <ActivityLogsList
          id={activeId}
          type={activeType}
          hideTitle
          showEmptyState
        />
      </div>
    </CustomModal>
  );
};

export default ActivityLogsPopup;
